/**
 * Event Preview Modal constants
 * Constantes para o modal de preview de eventos
 */

export const PREVIEW_SECTIONS = {
  DETAILS: 'details',
  DATES: 'dates',
  DISPLAY: 'display'
}

export const PREVIEW_LABELS = {
  MODAL_TITLE: 'Revisar cadastro',
  SECTION_DETAILS: 'Detalhes',
  FIELD_LIMIT_PER_CPF_EVENT: 'Limite por CPF (evento):',
  SECTION_DATES: 'Datas dos eventos e regras de resgate',
  SECTION_DISPLAY: 'Exibição no site',
  BUTTON_BACK: 'Voltar',
  BUTTON_CONFIRM: 'Confirmar',
  FIELD_TYPE: 'Tipo:',
  FIELD_NAME: 'Nome:',
  FIELD_DESCRIPTION: 'Descrição:',
  FIELD_IMAGE: 'Imagem do Evento:',
  FIELD_BRANDS: 'Brands:',
  FIELD_START: 'Início',
  FIELD_END: 'Fim',
  FIELD_DATE: 'Data:',
  FIELD_TIME: 'Hora:',
  FIELD_TICKET_QUANTITY: 'Quantidade de Ingressos:',
  FIELD_LIMIT_PER_CPF: 'Limite por CPF:',
  FIELD_REDEMPTION: 'Resgate:',
  DAY_LABEL: (index) => `Dia ${index + 1}`,
  POINTS_LABEL: (points) => `${points} pontos`,
  NO_INFO: 'Não informado',
  NO_IMAGE: 'Sem imagem',
  DISPLAY_DISCLAIMER:
    'Para os clientes que efetuarem o resgate do ingresso, a visualização do evento se mantém até a data de sua realização.'
}
